/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateTemplateListMutationVariables = Types.Exact<{
  input: Types.CreateTemplateListInput;
}>;


export type CreateTemplateListMutation = { createTemplateList: { __typename: 'CreateTemplateListResult', templateList: { __typename: 'TemplateList', id: string } } };


export const CreateTemplateListDocument = gql`
    mutation CreateTemplateList($input: CreateTemplateListInput!) {
  createTemplateList(input: $input) {
    templateList {
      id
    }
  }
}
    `;
export type CreateTemplateListMutationFn = Apollo.MutationFunction<CreateTemplateListMutation, CreateTemplateListMutationVariables>;

/**
 * __useCreateTemplateListMutation__
 *
 * To run a mutation, you first call `useCreateTemplateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateListMutation, { data, loading, error }] = useCreateTemplateListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateListMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateListMutation, CreateTemplateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateListMutation, CreateTemplateListMutationVariables>(CreateTemplateListDocument, options);
      }
export type CreateTemplateListMutationHookResult = ReturnType<typeof useCreateTemplateListMutation>;
export type CreateTemplateListMutationResult = Apollo.MutationResult<CreateTemplateListMutation>;
export type CreateTemplateListMutationOptions = Apollo.BaseMutationOptions<CreateTemplateListMutation, CreateTemplateListMutationVariables>;